import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Template } from 'gung-common';

@Component({
  selector: 'lib-api-item-editor-modal',
  templateUrl: './api-item-editor-modal.component.html',
  styleUrl: './api-item-editor-modal.component.scss',
  standalone: false
})
export class ApiItemEditorModalComponent {
  @Input('item')
  set item(value) {
    const item = JSON.parse(value);
    this.submitForm.patchValue(item);
  }

  @Input() isActuator: boolean;

  @Input()
  public cloneItem: boolean;

  private _selectedTemplate!: Template;

  @Input()
  set selectedTemplate(value: Template) {
    this._selectedTemplate = value;
  }

  get selectedTemplate(): Template {
    return this._selectedTemplate;
  }

  submitForm: FormGroup;

  constructor(protected formBuilder: FormBuilder, public ngbActiveModal: NgbActiveModal) {
    this.setForm();
  }

  setForm() {
    this.submitForm = this.formBuilder.group({
      active: this.formBuilder.control(false),
      ignoreErrors: this.formBuilder.control(false),
      title: this.formBuilder.control(''),
      targetPath: this.formBuilder.control(''),
      expression: this.formBuilder.control('')
    });
  }

  updatePath(path: string) {
    this.submitForm.patchValue({
      expression: path
    });
  }

  onSubmit() {
    if (!this.submitForm.valid) {
      this.submitForm.markAllAsTouched();
      return;
    }
    const item = this.submitForm.getRawValue();
    this.submitForm.reset();
    this.ngbActiveModal.close(JSON.stringify(item));
  }

  getSelectedEntity() {
    if (this.selectedTemplate) {
      return this.apiEntityToEntityMap[this.selectedTemplate.apiBaseEntityName];
    }
    return '';
  }

  apiEntityToEntityMap = {
    'availabilities': 'AVAILABILITY',
    'products': 'PRODUCT',
    'prices': 'PRICE',
    'deliveries': 'DELIVERY',
    'customers': 'CUSTOMER',
    'metadata': 'METADATA',
    'categories': 'CATEGORY',
    'customerContacts': 'CUSTOMER_CONTACT',
    'orders': 'ORDER'
  }
}
